import React from 'react';
import PropTypes from 'prop-types';
import { DaButton } from '@paygreen/paygreen-ui';
import IconByName from '../../utils/IconByName';

const SimpleActionButton = ({
    buttonSize,
    children,
    icon,
    onClick,
    buttonStyle,
    ...rest
}) => (
    <button type="button" onClick={onClick}>
        <DaButton
            buttonSize={buttonSize}
            buttonStyle={buttonStyle}
            colorPallet="status"
            colorStatus="default"
            icon={<IconByName name={icon} />}
            {...rest}
        >
            {children}
        </DaButton>
    </button>
);

SimpleActionButton.propTypes = {
    onClick: PropTypes.func,
    buttonSize: PropTypes.string,
    buttonStyle: PropTypes.string,
    icon: PropTypes.string,
    type: PropTypes.string,
};

SimpleActionButton.defaultProps = {
    buttonSize: 'sm',
    buttonStyle: 'line',
    icon: 'OutIcon',
    type: 'button',
};

export default SimpleActionButton;
